import React, { memo } from 'react'

import { fancyTimeFormat } from '../helpers/fancyTimeFormat'

const buildings = require('../config/all-buildings.json')
const upgradePBGID = require('../config/ageUpUpgrades.json')
const allTechs = require('../config/all-unified-techs.json')

// pbgid -> { name, icon } for every landmark building variation
const buildingsByPbgid = buildings.reduce((map, item) => {
	item.variations.forEach((variation) => {
		map[variation.pbgid] = { name: item.name, icon: item.icon }
	})
	return map
}, {})

function findTechByPbgid(pbgid) {
	for (const entries of Object.values(allTechs)) {
		const found = entries.find((item) => String(item.pbgid) === String(pbgid))
		if (found) return found
	}
	return null
}

// Abbasid wings / Ottoman age ups are upgrades, not buildings, so they are not in all-buildings.json
function getUpgradeByPbgid(pbgid) {
	return upgradePBGID.find((item) => item.pbg_id.includes(pbgid)) ?? null
}

/** Landmark icons come from the summary when present, otherwise resolved from the pbgid. */
function resolveIcon(landmark) {
	if (landmark.icon) return landmark.icon

	const pbgid = parseInt(landmark.pbgid)

	return buildingsByPbgid[pbgid]?.icon ?? getUpgradeByPbgid(pbgid)?.icon ?? findTechByPbgid(pbgid)?.icon ?? '/liveGameIcons/unknown.png'
}

// Some names carry extra info, e.g. "House of Wisdom (Culture Wing)" -> "House of Wisdom"
function cleanName(name) {
	return String(name ?? '')
		.replace(/\s*\([^)]*\)/g, '')
		.trim()
}

// side: 'left' keeps the icon on the icon-first side, 'right' mirrors the row so the icon sits on the outer edge
const LandmarkDisplay = memo(({ landmarks, side = 'left', className = '' }) => {
	// Only the landmarks/wings that aged the player up, oldest first
	const ageUps = (landmarks ?? [])
		.filter((landmark) => !!landmark?.newAge)
		.slice()
		.sort((a, b) => a.gameTime - b.gameTime)

	if (!ageUps.length) return null

	return (
		<div className={`landmarks landmarks--${side} ${className}`.trim()}>
			{ageUps.map((landmark, index) => (
				<div key={`${landmark.pbgid}-${landmark.gameTime}-${index}`} className={`landmarks__item landmarks__item--age${landmark.newAge}`}>
					<div className="landmarks__iconBox" style={{ backgroundImage: `url(/liveGameIcons/empty_background.png)` }}>
						<img className="landmarks__icon" src={resolveIcon(landmark)} alt="" />
					</div>
					<div className="landmarks__name">{cleanName(landmark.name || buildingsByPbgid[parseInt(landmark.pbgid)]?.name)}</div>
					<div className="landmarks__time">{fancyTimeFormat(landmark.gameTime)}</div>
				</div>
			))}
		</div>
	)
})

export { LandmarkDisplay }
